/* ============================================================
   Maui Craft Creations — Scroll Animation (Intersection Observer)
   Replicates Framer Motion whileInView / FadeUp component
   ============================================================ */

(function () {
  'use strict';

  /* Bail out if user prefers reduced motion */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    /* Make all .fade-up elements immediately visible */
    document.querySelectorAll('.fade-up').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  /* Also bail if IntersectionObserver isn't supported */
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.fade-up').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  function initFadeUpObserver() {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseFloat(el.dataset.delay || '0');
            el.style.transitionDelay = delay + 's';
            el.classList.add('is-visible');
            observer.unobserve(el);
          }
        });
      },
      {
        rootMargin: '-60px 0px',
        threshold: 0
      }
    );

    document.querySelectorAll('.fade-up').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeUpObserver);
  } else {
    initFadeUpObserver();
  }

})();
